import {useSelector, useDispatch} from 'react-redux';
import { Menu, Popover } from 'antd';
import {
  MoreOutlined,
  ShrinkOutlined,
  ArrowsAltOutlined,
  UserOutlined,
  ShareAltOutlined,
} from '@ant-design/icons';

import ShareLink from "./ShareLink";
import { RootState } from '../../../store/store';
import {menuShowDrawner,closeDrawner,menuItemSelected, menuFullScreen} from '../../../actions/menuAction';
import Profile from "../Profile";

const MobileMenu = () => {
  const reportState = useSelector((state:RootState) => state.report);
  const menuState = useSelector((state:RootState) => state.menu);
  const docElement = document.documentElement;
  const dispatch = useDispatch();

  const menuDrawer = () => {
    menuState.menu.showDrawer ? dispatch(closeDrawner()):dispatch(menuShowDrawner());
  };

  const handleSelectedKey = (e:any) => {
    e.key === menuState.menuItemSelected ? dispatch(menuItemSelected('0')) :
    dispatch(menuItemSelected(e.key))
  };

  const exitFullscreen=()=>{
    if (document.fullscreenElement)
    document.exitFullscreen()
  }

  const handleFullScreenClick=()=>{
    dispatch(menuFullScreen(!menuState.menu.fullScreen));
    (menuState.menu.fullScreen) ? exitFullscreen():  docElement.requestFullscreen();
  }
    return (
      <>
      <Menu theme={reportState.report.config?.showHeader ? "light":"dark"} mode="horizontal" onClick={handleSelectedKey} selectedKeys={menuState.menuItemSelected} style={{ justifyContent:'flex-start', background:reportState.report.config?.showHeader ?'#F3F2F1':'#0050b3' }}>
        <Menu.Item key='1' icon={<MoreOutlined style={{ fontSize: '120%', color:reportState.report.config?.showHeader ? '#000': 'inherit'}}/>} onClick={menuDrawer} />
        <Menu.Item key='2' style={{marginLeft:'auto'}}  icon={menuState.menu.fullScreen ? <ShrinkOutlined style={{ fontSize: '120%'}} onClick={handleFullScreenClick}/>:<ArrowsAltOutlined style={{ fontSize: '120%'}} onClick={handleFullScreenClick}/>} />
        <Popover className="test" placement="bottom" content={<ShareLink/>} trigger="click" arrowPointAtCenter>
          <Menu.Item key='3' icon={<ShareAltOutlined style={{ fontSize: '120%'}}></ShareAltOutlined>}/>
        </Popover>
        <Popover placement="bottomRight" style={{textAlign:'center', margin:0, padding:0, border:0}} content={<Profile />} trigger="click" arrowPointAtCenter>
          <Menu.Item key='4' icon={<UserOutlined style={{ fontSize: '120%'}}/>} />
        </Popover>
      </Menu>
    </>
    );
}
export default MobileMenu;